import Vue from 'vue';
import App from './App';
import VueImgix from 'vue-imgix';

Vue.use(VueImgix, {
    domain: 'vuetube.imgix.net',
    defaultIxParams: {
        auto: 'format,compress',
        fit: 'crop',
        trim: 'auto',
        crop: 'faces,edges'
    }
})

new Vue({
   render: h => h(App)
}).$mount('#app');